import { render, staticRenderFns } from "./AssignProfilesForm.vue?vue&type=template&id=1179eb6e&scoped=true&"
import script from "./AssignProfilesForm.vue?vue&type=script&lang=js&"
export * from "./AssignProfilesForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignProfilesForm.vue?vue&type=style&index=0&id=1179eb6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1179eb6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1179eb6e')) {
      api.createRecord('1179eb6e', component.options)
    } else {
      api.reload('1179eb6e', component.options)
    }
    module.hot.accept("./AssignProfilesForm.vue?vue&type=template&id=1179eb6e&scoped=true&", function () {
      api.rerender('1179eb6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/AssignProfilesForm.vue"
export default component.exports